import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import cn from 'classnames'
import type {FC} from 'react'
// eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
import {LogoBarV2} from 'slices/LogoBar/v2/LogoBarV2'
import {Container} from 'src/common/Container'
import {PADDING_BOTTOM_CLASS, PADDING_TOP_CLASS} from 'src/common/paddingClasses'
import type {BackgroundColors} from 'src/common/types'

export type IntegrationsLogoBarProps = SliceComponentProps<Content.IntegrationsLogoBarSlice>

const backgroundMap: Record<
  string,
  {containerBg: BackgroundColors; gradientColor: BackgroundColors; isDarkMode: boolean}
> = {
  'Dark mode': {containerBg: 'Dark Green', gradientColor: 'Dark Green', isDarkMode: true},
  'Light mode - white': {containerBg: 'Moss White', gradientColor: 'Moss White', isDarkMode: false},
  'Light mode - grey': {containerBg: 'Grey/100', gradientColor: 'Grey/100', isDarkMode: false},
}

const IntegrationsLogoBar: FC<IntegrationsLogoBarProps> = ({slice}) => {
  const manualLogos = slice.primary.logos.map((logo) => logo.logo)
  const linkedLogoSet = isFilled.contentRelationship(slice.primary.image_or_logo_set) && slice.primary.image_or_logo_set

  const linkedLogos =
    linkedLogoSet && 'data' in linkedLogoSet && linkedLogoSet.data
      ? (linkedLogoSet.data as Content.ImageLogoSetDocumentData).images.map((item) => item.image_single)
      : []

  const logos = manualLogos.length > 0 ? manualLogos : linkedLogos

  const {containerBg, gradientColor, isDarkMode} =
    backgroundMap[slice.primary.background ?? 'Dark mode'] ?? backgroundMap['Dark mode']

  const ptClass = PADDING_TOP_CLASS[slice.primary.padding_top ?? 'None'] ?? ''
  const pbClass = PADDING_BOTTOM_CLASS[slice.primary.padding_bottom ?? 'None'] ?? ''

  return (
    <Container backgroundColor={containerBg} data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>
      <div className={cn('mx-auto w-full max-w-[1200px] px-5 xl:px-0', ptClass, pbClass)}>
        <LogoBarV2
          titleRte={slice.primary.logobar_text}
          logos={logos}
          isDarkMode={isDarkMode}
          gradientColor={gradientColor}
          disableTopMargin
        />
      </div>
    </Container>
  )
}

export default IntegrationsLogoBar
